import React from "react";
import "../src/styles/css/App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import PrivateRouter from "./routes/PrivateRouter.js";
import Index from "./views/Index.js";
import Login from "./views/login/Login.js";

export default function App() {
  return (
    <div className="App">
      <div className="app-routes">
        <BrowserRouter basename={process.env.REACT_APP_BROWSE_ROUTE}>
          <Switch>
            <Route exact path="/login" component={Login} />
            <PrivateRouter path="/" component={Index} />
          </Switch>
        </BrowserRouter>
      </div>
    </div>
  );
}
